import { Pipe, PipeTransform } from '@angular/core';
import { SearchableDropdownOption } from './searchable-dropdown.component';
import { toSearchableOptions } from './searchable-dropdown.utils';

/**
 * Template pipe: `items | searchableOptions:'name':'id':'—'` (optional empty row label).
 */
@Pipe({
  name: 'searchableOptions',
  standalone: true,
})
export class SearchableOptionsPipe implements PipeTransform {
  transform(
    items: Record<string, unknown>[] | null | undefined,
    labelKey: string,
    valueKey: string,
    emptyLabel?: string
  ): SearchableDropdownOption[] {
    return toSearchableOptions(
      items,
      labelKey,
      valueKey,
      emptyLabel != null && emptyLabel !== '' ? { label: emptyLabel, value: null } : undefined
    );
  }
}
